<template>
  <section :class="$style.counters">
    <IconSpeechBalloon :class="$style.counters__icon" />
    <span :class="[$style.counters__title, $style.title]"
      >現在のアプローチ数：</span
    >
    <KartePlannerCommentMonthlyAmountV20211
      v-if="
        props.kartePlannerCommentMonthlyAmount?.__typename ===
        'V2021_1KartePlannerCommentMonthlyAmount'
      "
      :class="$style.counters__content"
      :amount="props.kartePlannerCommentMonthlyAmount"
    />
    <KartePlannerCommentMonthlyAmountV20221
      v-if="
        props.kartePlannerCommentMonthlyAmount?.__typename ===
        'V2022_1KartePlannerCommentMonthlyAmount'
      "
      :class="$style.counters__content"
      :amount="props.kartePlannerCommentMonthlyAmount"
    />
    <KartePlannerCommentMonthlyAmountV20231
      v-if="
        props.kartePlannerCommentMonthlyAmount?.__typename ===
        'V2023_1KartePlannerCommentMonthlyAmount'
      "
      :class="$style.counters__content"
      :amount="props.kartePlannerCommentMonthlyAmount"
    />
  </section>
</template>

<script setup lang="ts">
import IconSpeechBalloon from '@/components/icons/IconSpeechBalloon.vue'
import type { KartePlannerCommentMonthlyAmountFragment } from './KartePlannerCommentMonthlyAmount.generated'
import KartePlannerCommentMonthlyAmountV20211 from './KartePlannerCommentMonthlyAmountV20211.vue'
import KartePlannerCommentMonthlyAmountV20221 from './KartePlannerCommentMonthlyAmountV20221.vue'
import KartePlannerCommentMonthlyAmountV20231 from './KartePlannerCommentMonthlyAmountV20231.vue'

const props = defineProps<{
  kartePlannerCommentMonthlyAmount: Maybe<KartePlannerCommentMonthlyAmountFragment>
}>()
</script>

<style lang="scss" module>
.counters {
  display: flex;
  align-items: center;
  padding: 10px 16px 12px;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-base;

  &__icon {
    height: 18px;
    padding-bottom: 2px;
    color: $color-text-and-object-high-emphasis;
  }

  &__title {
    color: $color-text-and-object-high-emphasis;
    font-size: 12px;
    font-weight: bold;
    line-height: 1em;

    &:nth-child(n + 2) {
      margin-left: 8px;
    }
  }

  &__content {
    &:nth-child(n + 2) {
      margin-left: 16px;
    }
  }
}
</style>
